// Minimal analytics emitter. The contract is the event name and payload shape, not the transport:
// a collector subscribes to the "offolio:analytics" window event. Payloads must never carry tokens,
// markup or user data. Never throws.
export const ANALYTICS_EVENT = "offolio:analytics";

export const trackEvent = (name, payload = {}) => {
  try {
    window.dispatchEvent(new CustomEvent(ANALYTICS_EVENT, { detail: { name, payload, at: Date.now() } }));
  } catch (e) { /* analytics must never break the caller */ }
  try {
    console.info("[analytics]", name, payload); // eslint-disable-line no-console
  } catch (e) { /* console unavailable */ }
};
